import type { IconComponent } from './icon'

export const Logo: IconComponent = ({ className }) => {
    return (
        <svg
            width="66"
            height="24"
            viewBox="0 0 66 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-label="XSY Trinity"
            className={className}
        >
            <title>XSY Trinity</title>
            <path
                d="M29.8394 14.1456C28.513 14.1456 27.3051 13.8271 26.2144 13.1888C25.1238 12.5505 24.2525 11.6974 23.6019 10.6308C22.95 9.56417 22.6248 8.37524 22.6248 7.06539C22.6248 5.75552 22.95 4.58392 23.6019 3.51602C24.2538 2.44936 25.125 1.59628 26.2144 0.958018C27.3051 0.319752 28.513 0 29.8394 0H43.3597L40.0222 4.72096H29.8394C29.1762 4.72096 28.6114 4.94934 28.1448 5.40614C27.6783 5.86292 27.445 6.416 27.445 7.06539C27.445 7.71476 27.6783 8.28386 28.1448 8.74067C28.6114 9.19748 29.1762 9.42589 29.8394 9.42589H36.1438C37.4702 9.42589 38.6781 9.74558 39.7688 10.3826C40.8581 11.0209 41.7294 11.8765 42.3813 12.9493C43.0331 14.0221 43.3584 15.2085 43.3584 16.5061C43.3584 17.8036 43.0318 18.9875 42.3813 20.0554C41.7294 21.1233 40.8581 21.9764 39.7688 22.6134C38.6781 23.2517 37.4702 23.5702 36.1438 23.5702H22.505L25.8425 18.8492H36.1438C36.807 18.8492 37.3719 18.6209 37.8384 18.1641C38.3049 17.7073 38.5381 17.1542 38.5381 16.5048C38.5381 15.8555 38.3049 15.2999 37.8384 14.8382C37.3719 14.3764 36.807 14.1443 36.1438 14.1443H29.8394V14.1456Z"
                fill="white"
            />
            <path
                d="M7.42364 13.2357L0.118164 23.5714H5.98372L10.3488 17.3764L7.42994 13.2456L7.42364 13.2357Z"
                fill="white"
            />
            <path d="M7.4303 10.5172L10.353 6.38267L5.84917 0H0L7.42778 10.5209L7.4303 10.5172Z" fill="white" />
            <path d="M58.5697 10.5172L55.6482 6.38267L60.1508 0H66L58.5735 10.5209L58.5697 10.5172Z" fill="white" />
            <path
                d="M9.33943 10.5308L16.7912 0H22.6416L15.1899 10.5308C14.6162 11.4333 14.6162 12.3295 15.1899 13.2209L22.5067 23.5702H16.6563L9.33943 13.2209C8.76576 12.3295 8.76576 11.4333 9.33943 10.5308Z"
                fill="#27FD55"
            />
            <path
                d="M56.6616 10.5308L49.2099 0H43.36L50.8112 10.5308C51.3849 11.4333 51.3849 12.3295 50.8112 13.2209L43.4944 23.5702H49.3448L56.6616 13.2209C57.2353 12.3295 57.2353 11.4333 56.6616 10.5308Z"
                fill="#27FD55"
            />
        </svg>
    )
}
